import styled from 'styled-components';

const BlogPostShareStyles = styled.div`
  width: 100%;
  margin: 0 0 4rem 0;

  .meta {
    margin: 0 0 2rem;
    text-align: center;
    opacity: 0.7;

    .published,
    .modified {
      font-size: 0.85rem;

      .date {
        opacity: 0.6;
      }
    }

    .published {
      margin: 0;
    }
  }

  .share {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin: 2rem 0 0;
    column-gap: 2.25rem;
    row-gap: 1rem;
    text-align: center;

    .heading {
      margin: 0;
      font-weight: var(--font-weight-light);
      line-height: 1;
    }

    ul {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      padding: 0;
      list-style-type: none;

      li {
        margin: 0 0.5rem;

        .link {
          padding: 0.5rem;
          line-height: 1;

          .icon {
            width: 1.5rem;
            transition: fill 0.4s;
          }

          &:hover,
          &:focus {
            .icon {
              fill: #000;
            }
          }
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .meta {
      .published,
      .modified {
        font-size: 1rem;
      }
    }
  }
`;

export default BlogPostShareStyles;
